
import { defineComponent } from "vue";
import TokenService from "../../../services/TokenService";
import ResponseData from "../../../_models/ResponseData";
import { Helper } from "@/utils/Helper";
import store from "@/store/index";

// area for modals import
import uploadTokenPhoto from '@/modules/tokens/components/modals/tokensUploadTokenPhotoModal.vue';
import tokensCreateMainnetAssetComponent from '@/modules/tokens/components/tokensCreateMainnetAssetComponent.vue';
import tokensLinkedGamesComponent from '@/modules/tokens/components/tokensLinkedGamesComponent.vue';

export default defineComponent({
  name: 'viewTokensUpdate',
  components: {
    uploadTokenPhoto,
    tokensCreateMainnetAssetComponent,
    tokensLinkedGamesComponent,
  },
  data: function () {
    return {
      Helper: Helper,
      imageFile: "",
      fileName: "",
      previewImage: "",
      oriPreviewImage: "",
      tokenId: "",
      tokenName: "",
      tokenTitle: "",
      tokenSymbol: "",
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      tokenData: [],
      
      name: "",
      isDisplayUpdateTokenModal: false,
      mainTabSelected: 'supply',

      isDisplayUploadTokenImageLabel: false,
      isDisplaySaveTokenImageOptions: false,
      isDisplaySaveTokenImageUploading: false,

      showLoader: true,
    };
  },
  methods: {
    selectImage() {
      this.$refs.fileInput.click();
    },

    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      this.fileName = file[0].name;
      this.imageFile = file;

      if (file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
        this.isDisplaySaveTokenImageOptions = true;
      }
    },

    revertTokenImage(){
      this.previewImage = this.oriPreviewImage;
      this.isDisplaySaveTokenImageOptions = false;
      this.$refs.fileInput.value = null;
    },

    updateTokenImage() {
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.testnetTokenId !== undefined) {
        this.isDisplaySaveTokenImageOptions = false;
        this.isDisplaySaveTokenImageUploading = true;
        let tokenId = this.testnetTokenId!='-'?this.$route.params.testnetTokenId.toString():this.$route.params.mainnetTokenId.toString();
        let formData = new FormData();

        if (this.imageFile !== "") {
          formData.append("logoStream", this.imageFile[0]);

          TokenService.updateTokenDetails(tokenId, this.userData.userId, this.jwtToken, this.testnetTokenId!='-'?'testnet':'mainnet', formData)
            .then((response: ResponseData) => {
              Helper.toastSuccessHandling(response.data['message']);
              this.tokenName = this.tokenTitle;
              this.isDisplaySaveTokenImageUploading = false;
            })
            .catch((error) => {
              Helper.endpointErrorHandling(error);
              // console.log(error.response);
            });
        }
      }
    },

    getTokenDetails() {
      let tokenId = this.testnetTokenId!='-'?this.$route.params.testnetTokenId.toString():this.$route.params.mainnetTokenId.toString();

      if (tokenId !== undefined && this.userData !== "") {
        TokenService.getToken(tokenId, this.userData.userId, this.testnetTokenId!='-'?'testnet':'mainnet')
          .then((response: ResponseData) => {
            console.log(response.data)
            this.tokenName = this.tokenTitle = response.data.title?response.data.title:response.data.description;
            this.tokenSymbol = response.data.symbol;
            this.tokenData = {...response.data, formattedAmount: Helper.convertToCurrency(response.data.amount)};
            this.previewImage = this.assetUrl + "blob/tokens/" + tokenId + "/" + response.data.logo;
            this.oriPreviewImage = this.assetUrl + "blob/tokens/" + tokenId + "/" + response.data.logo;
            this.showLoader = false;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error, 'Fetching of Token Details failed!');
          });
      }
    },

    

    /*updateTokenName() {
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.tokenId !== undefined) {
        let tokenId = this.$route.params.testnetTokenId.toString();
        let formData = new FormData();

        if (this.tokenTitle !== "" && this.tokenSymbol) {
          formData.append("title", this.tokenTitle);
          formData.append("symbol", this.tokenSymbol);

          if (this.imageFile !== "") {
            formData.append("logoStream", this.imageFile[0]);
          }

          TokenService.updateTokenDetails(tokenId, this.userData.userId, this.jwtToken, formData)
            .then((response: ResponseData) => {
              Helper.toastSuccessHandling(response.data['message']);
              this.tokenName = this.tokenTitle;
              this.isDisplayUpdateTokenModal = false;
            })
            .catch((error) => {
              Helper.endpointErrorHandling(error);
            });
        } else {
          Helper.endpointErrorHandling('', 'Token name or symbol is empty!');
        }
      }
    },*/
  },

  computed: {
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    assetUrl() {
      return store.getters['config/assetUrl'];
    },
    typeLabel(){
      if(this.tokenData.type == 'IGT'){
        return 'In-Game Token';
      }else if(this.tokenData.type == 'LET'){
        return 'Limited Edition Token';
      }else{
        return 'Non-Fungible Token';
      }
    },
    testnetTokenId(){
      return this.$route.params.testnetTokenId;
    }
  },

  mounted() {
    this.getTokenDetails();
  },
});
